<template>
  <div class="atb-header-wrapper atb-flex atb-bg-color-primary_dark">
    <div v-if="!isCollapse" class="atb-header-title">
<!--      <i class="icon-logo"></i>-->
      <img class="logo" src="@/assets/images/logo.png">
    </div>
    <div class=" atb-logo-collapse" v-else>
      <i class="icon-indent" @click="collapse"></i>
    </div>
    <div class="atb-flex-1 atb-flex atb-flex-items-center">
      <i v-if="!isCollapse" class="icon-retract" @click="collapse"></i>
      <div>
        <span v-for="item in navList" :key="item.url">
          <span class="pre" @click="go(item)">{{item.name}}</span>
          <span class="split">/</span>
        </span>
        <!-- <span class="pre" v-if="preMenu" @click="go()">{{preMenu.name}}</span>
        <span class="split" v-if="preMenu">/</span> -->
        <span>{{menuName}}</span>
      </div>
    </div>
    <div class="atb-flex atb-flex-items-center">
      <div class="opt-item search-input">
        <MenuQuickSearch></MenuQuickSearch>
      </div>
      <el-select class="opt-item scale" v-model="displayScale"  @change="handleChange" placeholder="显示比例" :popper-append-to-body="false">
        <el-option
          v-for="item in DisplayScaleList"
          :key="item.id"
          :label="item.itemValue"
          :value="item.itemValue"
          popper-class="scale-item">
        </el-option>
      </el-select>
      <div class="opt-item full-screen" :title="isFullScreen? '退出全屏': '全屏'">
        <i :class='[isFullScreen ? "icon-suoxiao":"icon-quanping"]' @click.stop='openFullScreen'></i>
      </div>
      <div class="opt-item" v-if="$auth(that, 'Approve','OEC.MonitorCenter')" @click="checkApproveMsg" title="工作审批">
        <i class="icon-news"></i>
         <span v-if="noticeCount.approveCount>0" class="notice">{{noticeCount.approveCount}}</span>
      </div>
      <div class="opt-item " v-if="$auth(that, 'Notification','OEC.MonitorCenter')" @click="checkNotificationMsg" title="消息提醒">
        <i class="icon-warning"></i>
         <span v-if="noticeCount.notificationCount>0" class="notice">{{noticeCount.notificationCount}}</span>
      </div>
      <div class="opt-item msg" title="使用说明下载" @click="downManual">
        <i class="icon-manual"></i>
      </div>
      <div class="opt-item atb-flex atb-flex-items-center">
        <el-dropdown @command="handleCommand" ref="dropdownOption" placement="bottom-end">
          <div class="userInfo atb-flex atb-flex-items-center">
            <span class="username">{{username}}</span>
            <span :style="iconUrl&&{background:`url(${iconUrl})`,backgroundSize:'100%'}" class="avatar el-dropdown-link">
              <!-- <img v-if="iconUrl" class="avatar-icon" :src="iconUrl"> -->
            </span>
          </div>
          <el-dropdown-menu slot="dropdown" @command="handleCommand" ref="dropdownOptionMenu" class="avatar-dropdown" :append-to-body="false">
            <el-dropdown-item command="setExpand" class="no-dropdown-style">
              <div @click.stop.prevent>
                表格行展开
                <el-switch
                  v-model="isRowExpand"
                  :active-text="isRowExpand ? '开' : '关'"
                  inactive-text=""
                  @change="setRowExpand"
                >
                </el-switch>
              </div>
            </el-dropdown-item>
            <el-dropdown-item v-if="!hasPass" command="addPassword">设置密码</el-dropdown-item>
            <el-dropdown-item v-if="hasPass" command="modifyPassword">修改密码</el-dropdown-item>
            <el-dropdown-item v-if="hasPass" command="resetPassword">重置密码</el-dropdown-item>
            <el-dropdown-item command="logout">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-dialog title="设置密码" v-if="showAddPwd" :visible.sync="showAddPwd" width="450px" custom-class="changeDialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content write-summary">
        <el-form ref="addPwdForm" :model="addForm" :rules="addPwdFormRules" label-width="85px" label-position="right" >
          <el-form-item label="用户名:">
              <span>{{userObj.wkNo||''}}</span>
          </el-form-item>
          <el-form-item label="设置密码:" prop="password">
            <el-input v-model.trim="addForm.password" type="password" autocomplete="off" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="addSubmit">提交</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showAddPwd = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改密码" v-if="showModifyPwd" :visible.sync="showModifyPwd" width="500px" custom-class="changeDialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content write-summary">
        <el-form ref="pwdForm" :model="modifyform" :rules="modifyPwdFormRules" label-width="100px" label-position="right" >
          <el-form-item label="旧密码:" prop="currentPassword">
            <el-input v-model.trim="modifyform.currentPassword" type="password" autocomplete="off" clearable></el-input>
          </el-form-item>
          <el-form-item label="新密码:" prop="newPassword">
            <el-input v-model.trim="modifyform.newPassword" type="password" autocomplete="off" clearable></el-input>
          </el-form-item>
          <el-form-item label="确认新密码:" prop="checkPassword">
            <el-input v-model.trim="modifyform.checkPassword" type="password" autocomplete="off" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="modifySubmit">提交</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showModifyPwd = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" custom-class="reset-pwd" :visible.sync="showResetPwdTip" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要重置吗</h2>
        <p>重置密码后需重新设置密码</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="resetPwd">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showResetPwdTip = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import MenuQuickSearch from './MenuQuickSearch';
export default {
  components: {
    MenuQuickSearch,
  },
  data() {
     var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          const pawRule = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])\S{8,}$/;
          if(!pawRule.test(value)){
            callback(new Error('密码中必须包含数字、大小写字母、特殊字符，并且不能少于8位。'));
          }
          if (this.modifyform.checkPassword !== '') {
            this.$refs.pwdForm.validateField('checkPassword');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.modifyform.newPassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
    };
    var validateRule=(rule,value, callback)=>{
      // const pawRule= /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/;
      const pawRule = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])\S{8,}$/;
      if(!pawRule.test(value)){
        callback(new Error('密码中必须包含数字、大小写字母、特殊字符，并且不能少于8位。'));
      }else{
        callback();
      }
    }
    return {
      tianQi: {},
      isSearch: false,
      isFullScreen: false,
      isCollapse: false,
      username: sessionStorage.getItem("USER_DESC"),
      iconUrl:'',
      that:this,
      preMenu: JSON.parse(sessionStorage.getItem("preMenu")),
      displayScale: '100%',
      DisplayScaleList:[],
      win:window,
      showAddPwd:false,
      showModifyPwd:false,
      addForm:{},
      modifyform:{},
      addPwdFormRules:{ 
        password: [
          { required: true,validator: validateRule, trigger: 'blur' }
        ]
      },
      modifyPwdFormRules:{ 
        currentPassword: [
          { required: true, trigger: 'blur', message: "请输入旧密码"},
          { required: true, trigger: 'blur', message: "请输入旧密码" }
        ],
        newPassword: [
          { required: true, validator: validatePass, trigger: 'blur' },
          { required: true, validator: validateRule, trigger: 'blur' }
        ],
        checkPassword: [
          { required: true, validator: validatePass2, trigger: 'blur' },
          { required: true, validator: validateRule, trigger: 'blur' }
        ]
      },
      hasPass:false,
      userObj:{},
      showResetPwdTip:false,
      isRowExpand: true, // 是否启用年、月、周、绩效考核等表格行点击时展开行内容
    }
  },
  computed:{
    menuName() {
      return this.$store.state.common.menuName;
    },
    noticeCount() {
      return this.$store.state.common.noticeCount;
    },
    navList() {
      return this.$store.state.common.navList;
    },
  },
  created() {
    this.$bus.$on('onkeydown',this.onkeydown)
    this.isFullScreenFunc()
    window.addEventListener('resize',this.isFullScreenFunc)
    window.addEventListener('setItem', (e) => {
      this.preMenu = JSON.parse(e.newValue);
    });
    const userObj=JSON.parse(sessionStorage.getItem('userInfo'));
    this.userObj=userObj;
    this.iconUrl=userObj&&userObj.headImgUrl||'';
    this.hasPass=userObj&&userObj.hasPass? userObj.hasPass: false;
    sessionStorage.getItem('zoom')&&(this.win.document.body.style.zoom = sessionStorage.getItem('zoom'));
    // console.log(this.$route.matched);

    this.isRowExpand = this.$getRowExpandFlag();
  },
  mounted(){
    this.getDisplayScale();
  },
  destroyed () {
    this.$bus.$off('onkeydown');
  },
  methods: {
    downManual() {
      this.$ajax.get(this.$api.home.common.readMe, {}, { ignore: true, responseType: 'blob' }).then((res) => {
        if (res.data.type == 'application/json') {
          var reader = new FileReader();
          reader.onload = () => {
            var content = reader.result; //内容就在这里
            let json = JSON.parse(content);
            this.$message.error(json.message);
          };
          reader.readAsText(res.data);
        } else {
          const filename = 'OEC系统操作说明';
          const filetype = 'pdf';
          let data = res.data;
          let url = window.URL.createObjectURL(data);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = filename + '.' + filetype;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      });
    },
    handleCommand(item) {
      if (item == 'logout') {
        // console.log(this.$mgr);
        this.$userInfo.clearLoginInfo();
        this.$mgr.signoutRedirect();
      }else if(item == 'modifyPassword'){
        this.showModifyPwd=true;
        this.modifyform={};
      }else if(item == 'addPassword'){
        this.showAddPwd=true;
        this.addForm={};
      }else if(item == 'resetPassword'){
        this.showResetPwdTip=true;
      }
    },
    collapse() {
      this.isCollapse = !this.isCollapse;
      this.$store.commit('common/updateCollapse', this.isCollapse);
    },
    checkApproveMsg(){
      if(this.$router.currentRoute.path!=='/notice/approve')
      this.$router.push({
        path: '/notice/approve',
      });
    },
    checkNotificationMsg(){
      if(this.$router.currentRoute.path!=='/notice/index')
       this.$router.push({
        path: '/notice/index',
      });
    },
    openFullScreen(){
      this.isFullScreen=!this.isFullScreen;
      if(this.isFullScreen){
        var element = document.documentElement;
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        } else if (typeof window.ActiveXObject != "undefined"){
          const wscript = new ActiveXObject("WScript.Shell");
          if (wscript!=null) {
            wscript.SendKeys("{F11}");
          }
        }
      }else{
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (typeof window.ActiveXObject != "undefined"){
          const wscript = new ActiveXObject("WScript.Shell");
          if (wscript!=null) {
            wscript.SendKeys("{F11}");
          }
        }
      }
    },
    isFullScreenFunc(){
      setTimeout(() => {
        this.isFullScreen =!!(document.webkitIsFullScreen || document.mozFullScreen || 
        document.msFullscreenElement || document.fullscreenElement)
      }, 10);
    },
    onkeydown(event){
      if(event && event.keyCode == 122){
        event.preventDefault()
        this.openFullScreen(!this.isFullScreen)
      }else if(event && event.keyCode == 121){
        event.preventDefault()
      }
      this.isFullScreenFunc()
    },
    go(menu) {
      this.$store.commit('common/backNavList',menu);
      this.$router.push(menu.url);
    },
    async getDisplayScale(){
      await this.$ajax.get(this.$api.common.getDict,{ItemType:'DisplayScale'}).then((res) => {
        this.DisplayScaleList=res.data.rows||res.data||[];
      });
    },
    handleChange(val){
      if(val){
        this.win.document.body.style.zoom = 1*this.toPoint(val);
      }
    },
    toPoint(val){
      if(val){
        return val.replace('%','')/100;
      }
    },
    addSubmit(){
      this.$refs.addPwdForm.validate((valid) => {
         if (valid) {
          this.$ajax.post(this.$api.common.addpwd, this.addForm, {ignore:true}).then((res) => {
            if(res.data.succeeded){
              this.hasPass=true;
              this.showAddPwd=false;
              this.$message.success('保存成功');
              const userObj=JSON.parse(sessionStorage.getItem('userInfo'));
              userObj.hasPass=true;
              sessionStorage.setItem("userInfo",JSON.stringify(userObj));
            }else{
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    modifySubmit(){
      this.$refs.pwdForm.validate((valid) => {
         if (valid) {
          const {currentPassword,newPassword}=this.modifyform;
          this.$ajax.post(this.$api.common.changepwd, {currentPassword,newPassword}, {ignore:true}).then((res) => {
            if(res.data.succeeded){
              this.showModifyPwd=false;
              this.$message.success('保存成功');
            }else{
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    resetPwd(){
      this.$ajax.delete(this.$api.common.removepwd).then(() => {
        this.hasPass=false;
        this.showResetPwdTip=false;
        const userObj=JSON.parse(sessionStorage.getItem('userInfo'));
        userObj.hasPass=false;
        sessionStorage.setItem("userInfo",JSON.stringify(userObj));
        this.$message.success('重置成功');
      });
    },
    setRowExpand(val) {
      window.localStorage.setItem('_rowExpandFlag', val ? '1' : '0');
    },
  },
  watch: {
    $route() {
      // console.log(to.matched);
    }
  }
};
</script>
<style lang="scss">
.atb-header-wrapper {
  height: 60px;
  line-height: 60px;
  background-color: $--color-primary_dark;
  .atb-header-title {
    width: 320px;
    padding-left: 18px;
    i.icon-logo {
      font-size: 42px;
      color: $--color-white;
      position: relative;
      bottom: 4px;
    }
  }
  .atb-logo-collapse {
    width: 70px;
    text-align: center;
    i.icon-indent {
      font-size: 22px;
      cursor: pointer;
      color: $--color-white;
    }
  }
  .atb-flex-1 {
    padding-left: 24px;
    overflow: hidden;
    i {
      font-size: 23px;
      color: $--color-white;
      cursor: pointer;
      padding-right: 24px;
    }
    span {
      font-size: 20px;
      color: $--color-white;
      // position: absolute;
      // top:-1px;
      // left: 65px;
      // right: 0px;
      // bottom:0px;
      &.split{
        margin: 0 5px;
      }
      &.pre{
        cursor: pointer;
        color: rgba(#fff, 0.5);
        &:hover{
          color: rgba(#fff, 0.6);
        }
      }
    }
  }
  .opt-item {
    cursor: pointer;
    margin-right: 20px;
    position: relative;
    &.msg{
      margin-right: 40px;
    }
    i {
      color: $--color-white;
      vertical-align: middle;
      &.icon-news, &.icon-warning, &.icon-move{
        font-size: 26px;
      }
      &.icon-manual{
        font-size: 20px;
      }
    }
    .username{
      color: #fff;
      font-size: 15px;
      margin-right: 8px;
    }
    .avatar{
      display: block;
      width: 28px;
      height: 28px;
      background: $--color-black;
      border-radius: 50%;
      overflow: hidden;
    }
    .avatar-icon{
      display: block;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      overflow: hidden;
    }
    .notice {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 18px;
      padding: 0 3px;
      height: 18px;
      background: $--color-warning;
      border-radius: 9px;
      color: $--color-white;
      font-size: 12px;
      text-align: center;
      position: absolute;
      top: 12px;
      left: 16px;
      // padding: 1px 5px 5px 5px;
      vertical-align: middle;
    }
  }
  .avatar-dropdown {
    right: 0;
    top: 100%!important;
    left: initial!important;
    .el-dropdown-menu__item {
      white-space: nowrap;
    }
    .popper__arrow {
      left: initial!important;
      right: 20%;
    }
  }
  .scale{
    .el-input{
      width: 85px;
      input{
        background-color: #138c82;
        color: #fff;
        border: 0;
        font-size: 15px;
      }
      .el-select__caret{
        color: #fff;
      }
    }
  }
  .icon-retract:before {
    position: relative;
    top: 1px;
  }
  .el-icon-search:before {
    position: relative;
    bottom: 1px;
  }
  .el-input--prefix {
    input.el-input__inner {
    padding-left: 38px;
   }
   span{
    left: 8px;
   }
  }
  .atb-flex-items-center{
    position: relative;
    .search-input{
      margin-right: 40px;
    }
    .full-screen{
      i{
        font-size: 26px;
      }
    }
  }
  .reset-pwd {
    .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      line-height: 15px;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
  }
}
.menu-search-input {
  width: 300px;
  height: 32px;
  line-height: 32px;
  input{
    height: 32px;
    line-height: 32px;
  }
  .el-input__prefix {
    i.el-input__icon {
      color: $--color-input-icon;
      vertical-align: top;
      line-height: 34px;
    }
  }
  input {
    border-radius: 40px;
    background: rgba($--color-white, 0.85);
    &::-webkit-input-placeholder {
      color: $--color-input-icon;
    }
  }
}
.el-dialog{
 &.changeDialog{
  .wk_no{
    margin-bottom: 2px;
  }
 }
}
.el-dropdown-menu__item.no-dropdown-style {
  &:hover {
    background-color: #fff;
    color: #687371;
  }
}
</style>
